import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import fanyiPic from '@/assets/fanyi.png';
import { updateSeo } from '@/services/systemsetting';
export default {
  components: {},
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  watch: {
    systemSetting: function systemSetting() {
      var self = this;
      self.systemSettingData = self.systemSetting;
      self.initData();
    }
  },
  data: function data() {
    return {
      defaultLangObj: {},
      languageList: [],
      fanyiPic: fanyiPic,
      loadingSave: false,
      tabKey: '',
      systemSettingData: this.systemSetting,
      dataForm: {
        id: "",
        lastUpdateTime: "",
        seoList: []
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
    self.tabKey = self.defaultLangObj.langId;
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.initData();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      self.tabKey = activeKey;
      var seoListClone = self.dataForm.seoList;
      var _iterator = _createForOfIteratorHelper(seoListClone),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var one = _step.value;
          one.showTitleFY = false;
          one.showKeywordsFY = false;
          one.showDescFY = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    showFYBtn: function showFYBtn(key, obj) {
      if (key == 'title') {
        obj.showTitleFY = true;
        obj.showKeywordsFY = false;
        obj.showDescFY = false;
      } else if (key == 'keywords') {
        obj.showTitleFY = false;
        obj.showKeywordsFY = true;
        obj.showDescFY = false;
      } else if (key == 'desc') {
        obj.showTitleFY = false;
        obj.showKeywordsFY = false;
        obj.showDescFY = true;
      } else {
        obj.showTitleFY = false;
        obj.showKeywordsFY = false;
        obj.showDescFY = false;
      }
    },
    initData: function initData() {
      var self = this;
      var seoList = [];
      self.languageList.forEach(function (item) {
        var objDetail = {};
        objDetail.langId = item.langId;
        if (item.langId == self.defaultLangObj.langId) {
          objDetail.required = true;
        } else {
          objDetail.required = false;
        }
        objDetail.languageName = item.langName;
        objDetail.showTitleFY = false;
        objDetail.showKeywordsFY = false;
        objDetail.showDescFY = false;
        self.systemSettingData.seoList.forEach(function (item2) {
          if (item.langId == item2.langId) {
            objDetail.metaTitle = item2.metaTitle;
            objDetail.metaDesc = item2.metaDesc;
            objDetail.metaKeyword = item2.metaKeyword;
          }
        });
        seoList.push(objDetail);
      });
      self.dataForm.id = this.systemSetting.id;
      self.dataForm.lastUpdateTime = this.systemSetting.lastUpdateTime;
      self.dataForm.seoList = seoList;
    },
    /* 保存 */save: function save() {
      var _this = this;
      var self = this;
      var param = {
        id: self.dataForm.id,
        lastUpdateTime: self.dataForm.lastUpdateTime,
        list: self.dataForm.seoList
      };
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          self.loadingSave = true;
          updateSeo(param).then(function (result) {
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              self.$emit('update');
              _this.$message.success(_this.$t('public.saveSuccessfully'));
            }
            self.loadingSave = false;
          }).finally(function () {
            self.loadingSave = false;
          });
        } else {
          self.tabKey = self.defaultLangObj.langId;
        }
      });
    }
  }
};